import type { SessionKind } from "../hooks/audit/useControlSessionEnvelope";

/**
 * What a session's rerun instructions can be written back into: the control
 * spec for a control session, the work step for a work-step session.
 */
export const sessionSpecName = (sessionKind: SessionKind): string =>
  sessionKind === "work_step" ? "work step" : "control spec";
